var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysRatesAndAvailability = function SvgSysRatesAndAvailability(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.453 4.998a.418.418 0 0 0-.455.455A.499.499 0 0 1 6 5.5v12c0 .238.049.354.081.406.03.047.063.07.101.085a.418.418 0 0 0 .21.02l.01-.001A.5.5 0 0 1 6.5 18h3a.5.5 0 0 1 0 1H6.542l-.02.003a1.5 1.5 0 0 1-.704-.08 1.194 1.194 0 0 1-.586-.489C5.076 18.184 5 17.871 5 17.5V5.52A1.418 1.418 0 0 1 6.521 4h9.002A1.549 1.549 0 0 1 17 5.5v8a.5.5 0 1 1-1 0V5.513A.549.549 0 0 0 15.487 5H6.5c-.016 0-.031 0-.047-.002Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5ZM8 11.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5ZM19.854 14.146a.5.5 0 0 1 0 .708l-5 5a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708l1.646 1.647 4.646-4.647a.5.5 0 0 1 .708 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgSysRatesAndAvailability;